import { AvatarStack, Box, Card } from '@factorialco/deprecated-design-system'

import Callout from 'modules/core/components/Callout'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import i18n from 'modules/core/lib/i18n'

import generateAvatars from 'modules/employees/pages/BulkFixContractsPage/utils/generateAvatars'

import { ContractSummaryData } from '../CompensationsSummaryStep/NewCompensationWizard/types'

const ContractSummary = ({
  affectedEmployeeIds,
  targetEmployees,
  unaffectedEmployeeIds,
}: ContractSummaryData) => {
  const visibleAffectedAvatars = useUnsafeMemo(
    () => generateAvatars(affectedEmployeeIds, targetEmployees),
    [affectedEmployeeIds, targetEmployees]
  )
  const visibleUnaffectedAvatars = useUnsafeMemo(
    () => generateAvatars(unaffectedEmployeeIds, targetEmployees),
    [unaffectedEmployeeIds, targetEmployees]
  )

  return (
    <>
      <Card>
        <Card.Content>
          <Box width="full" gap="s16">
            <Callout
              compact
              type="info"
              description={i18n.tp('employees.bulk_edit.fix_conditions.steps.scope.num_affected', {
                count: affectedEmployeeIds.length,
              })}
            />
            <AvatarStack
              size="s32"
              avatars={visibleAffectedAvatars}
              leftover={affectedEmployeeIds.length - visibleAffectedAvatars.length}
              textSize="200"
              textColor="viridian100"
              backgroundColor="olive1000"
            />
          </Box>
        </Card.Content>
      </Card>
      {unaffectedEmployeeIds.length > 0 && (
        <Card>
          <Card.Content>
            <Box width="full" gap="s16">
              <Callout
                compact
                type="warning"
                description={i18n.tp(
                  'employees.bulk_edit.fix_conditions.steps.scope.num_unaffected',
                  {
                    count: unaffectedEmployeeIds.length,
                  }
                )}
              />
              <AvatarStack
                size="s32"
                avatars={visibleUnaffectedAvatars}
                leftover={unaffectedEmployeeIds.length - visibleUnaffectedAvatars.length}
                textSize="200"
                textColor="viridian100"
                backgroundColor="olive1000"
              />
            </Box>
          </Card.Content>
        </Card>
      )}
    </>
  )
}

export default ContractSummary
